import React from "react";
import ReactDOM from "react-dom"; 
import App from "./App";
import { msalInstance } from "./helper/authConfig";
import { MsalProvider } from "@azure/msal-react";

async function initializeMsal() {
  try {
    // Explicitly initialize MSAL
    await msalInstance.initialize();
    console.log("MSAL initialized successfully.");
    
    // Render the app after MSAL is initialized
    ReactDOM.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
      document.getElementById('root')
    );
  } catch (error) {
    console.error("Error initializing MSAL:", error);
    // Optionally, handle initialization errors (e.g., show an error screen)
  }
}

// Call the initialization function
initializeMsal();